"use client";

import { useEffect, useMemo, useState } from "react";
import { categoryLabelMap, categoryTreeFromMenu, type CategoryNode, type MenuItemLike } from "@/lib/category-filter";

// Het hoofdmenu (/api/navigation) één keer per paginalading ophalen en delen. De Header gebruikte dit al; het
// categoriefilter (MOW-CATEGORIEFILTER-OKT26) leest dezelfde boom. Zonder gedeelde belofte zou elke pagina de
// route twee keer aanroepen, en die leest bij elk verzoek drie collecties uit Firestore.

let menuBelofte: Promise<MenuItemLike[]> | null = null;

/** Het menu uit de data; een lege lijst bij een fout (en dan wordt er bij de volgende aanroep opnieuw geprobeerd). */
export function laadMenu(): Promise<MenuItemLike[]> {
  if (!menuBelofte) {
    menuBelofte = fetch("/api/navigation")
      .then((res) => (res.ok ? res.json() : null))
      .then((data): MenuItemLike[] => (Array.isArray(data?.items) ? data.items : []))
      .catch((): MenuItemLike[] => [])
      .then((items) => {
        if (items.length === 0) menuBelofte = null;
        return items;
      });
  }
  return menuBelofte;
}

/** De categorieboom uit het menu, en een label per slug voor de chips. `tree` is null zolang het menu niet binnen is. */
export function useCategoryTree(): { tree: CategoryNode[] | null; labels: Map<string, string> } {
  const [items, setItems] = useState<MenuItemLike[] | null>(null);
  useEffect(() => {
    let afgebroken = false;
    laadMenu().then((m) => {
      if (!afgebroken && m.length > 0) setItems(m);
    });
    return () => {
      afgebroken = true;
    };
  }, []);
  const tree = useMemo(() => (items ? categoryTreeFromMenu(items) : null), [items]);
  const labels = useMemo(() => categoryLabelMap(tree), [tree]);
  return { tree, labels };
}
